import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { OrdersService } from '../core/services/orders/orders.service';
import { MenuController, NavController } from '@ionic/angular';
import { ProductsService } from '../core/services/products/products.service';
import { ExtrasService } from '../core/services/extras/extras.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.page.html',
  styleUrls: ['./layout.page.scss'],
})
export class LayoutPage implements OnInit {

  constructor(
    public router: Router,
    public menu: MenuController, private navController: NavController, private ordersService: OrdersService,
    private productsService: ProductsService, private extraService: ExtrasService
  ) { }

  disabledProducts: number;
  pendingOrders: any = [];
  storeId: any;
  branchOffice: any;

  ngOnInit() {
    this.getPendingOrders();
  }

  ionViewWillEnter() {
    this.branchOffice = localStorage.getItem('branchOffice');
    this.disabledProducts = 0;
    this.getDisabledProducts();
    this.getDisabledExtras();
  }

  openMenu() {
    this.menu.open();
    this.menu.enable(true, 'first');
  }

  getDisabledProducts() {
    this.storeId = localStorage.getItem('storeId');
    this.productsService.getProducts(this.storeId).subscribe(categories => {
      for (let category of categories) {
        for (let product of category.products) {
          for (let store of product.stores) {
            if (store.id == this.storeId && store.StoreProduct.status == false) {
              this.disabledProducts = this.disabledProducts + 1;
            }
          }
        }
      }
    });
  }

  getDisabledExtras() {
    this.extraService.getExtrasByStoreId(localStorage.getItem('storeId')).subscribe(categories => {
      for (let category of categories) {
        for (let extra of category.productsExtra) {
          for (let store of extra.stores) {
            if (store.StoreProductExtra.status == false) {
              this.disabledProducts = this.disabledProducts + 1;
            }
          }
        }
      }
    });
  }

  getPendingOrders() {
    let storeId = localStorage.getItem('storeId');
    this.ordersService.getPaidOrdersByStore(storeId).subscribe(data => {
      this.pendingOrders = data.filter(order => order.comeFromSystem !== 'YUMMY' && order.comeFromSystem !== 'BACKOFFICE' && order.comeFromSystem !== 'COURTESY');
    });
  }

  backToNewOrder() {
    this.navController.navigateRoot(['/home/new-orders']);
  }
}
